import { render, staticRenderFns } from "./AllowedUserContainer.vue?vue&type=template&id=5adeb773&"
import script from "./AllowedUserContainer.vue?vue&type=script&lang=js&"
export * from "./AllowedUserContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports